export default __webpack_public_path__ + "static/media/App-store.aba0ca49.svg";